export const homeAbout = [
  {
    id: 1,
    cover: "https://img.icons8.com/dotty/80/000000/storytelling.png",
    title: "Industry-Relevant Curriculum",
    desc: "Tailored curriculum aligns with industry demands, ensuring that interns acquire the skills and knowledge sought after by employers.",
  },
  {
    id: 1,
    cover:"./images/logo/iso.png",
    title:"ISO/IAF Certified",
    desc :"At SharpCode, our commitment to excellence is confirmed by our ISO certification, ensuring top-tier education that adheres to  the highest standards for quality, consistency, and efficiency."
  },
  {
    id: 1,
    cover: "https://img.icons8.com/ios/80/000000/diploma.png",
    title: "Performance Recognition",
    desc: "Your work is acknowledged through certificates and exceptional performance with recommendations, providing interns with tangible proof of your remarkable accomplishments during the internship period.",
  },
  {
    id:1,
    cover:"./images/logo/msme.png",
    title:"MSME Certified",
    desc: "SharpCode is an MSME-certified company, demonstrating our legal compliance and commitment to uphold the highest standards in tech education and entrepreneurship."
  },
  {
    id: 1,
    cover: "https://img.icons8.com/ios/80/000000/athlete.png",
    title: "Flexible schedule",
    desc: "We understand the demands of academic life, so our internship offers flexible schedules to accommodate students' academic commitments.",
  },

]

export const team = [
  {
    cover: "./images/logo/front-end.jpg",
    name: "Frontend Development",
    details: "Unlock your potential with our comprehensive frontend development training and internship. Master HTML, CSS, JavaScript, React through training and quizzes. Build a portfolio with a hands-on project, ready to showcase on your resume and social media. Start your journey to becoming a skilled developer today!",
    price:"₹999",
  },
  {
    cover: "./images/logo/data-analysis.jpg",
    name: "Data Analytics",
    price:"₹999",
    details: "Embark on a journey in data analysis with our training and internship. Learn SQL, Tableau, Power BI for data visualization. Tackle real-world data challenges through hands-on projects. Enhance your resume, online presence, and elevate your career prospects today!",
  },
  {
    cover: "./images/logo/machine-learning.jpg",
    name: "Machine Learning",
    price:"₹999",
    details: "Attain expertise in Machine Learning through our comprehensive 4-week internship, unlocking exciting career prospects. Lay a robust foundation with hands-on experience in web application development and deployment in a nurturing environment.",
  },
  {
    cover: "./images/logo/stuani.jpg",
    name: "Fullstack Development",
    price:"₹999",
    details: "Unleash your potential in full stack development with our immersive training cum internship. Choose between MERN or MEAN stack and progress through levels with projects and quizzes. Craft a standout full stack project for your resume and social media. Begin your journey to mastering development today!",
  },
  {
    cover: "./images/logo/android.jpg",
    name: "Android Development",
    price:"₹999",
    details: "Unlock your potential in Android development with our training and internship. Learn Flutter, Dart, and Android Studio. Showcase your skills with a polished Android project, perfect for your resume. Start your journey to becoming a proficient Android developer today!",
  },
  {
    cover: "./images/logo/back-end.jpg",
    name: "Backend Development",
    price:"₹999",
    details: "Unlock your potential in backend development with our training and internship. Master Python, Node.js, PHP, Express, Django through projects and quizzes. Build a standout backend project for your resume. Start your journey to becoming a skilled backend developer today!",
  },
  {
    cover: "./images/logo/basics_of_programming.jpg",
    name: "Language Fundamentals",
    price:"₹999",
    details: "Unlock the fundamentals of programming with our versatile training cum internship program. Choose your preferred language - Python, C, C++, Java, or others - and embark on a journey to mastery. Progress through levels with hands-on projects and quizzes tailored to your language choice. Start your programming journey today!",
  },
  {
    cover: "./images/logo/data-science.jpg",
    name: "Data Science",
    price:"₹999",
    details: "Immerse yourself in distinctive remote data science internships, gaining invaluable experience within the virtual workforce. Explore highly sought-after niches, including competitive and favored data analysis opportunities.",
  },
  {
    cover: "./images/logo/DSA.jpg",
    name: "Data Structure and Algorithms",
    price:"₹999",
    details: "Master efficient coding with our DSA course. Essential for developers, it covers key data structures and algorithms. Learn to solve complex problems, optimize code, and build high-performance applications. Enroll now to enhance your skills and career.",
  },
]

export const faq = [
  {
    title: "Are SharpCode courses self-paced?",
    desc: "Yes, all our courses are self-paced, allowing you to learn at your convenience and fit your studies around your personal and professional life.",
  },
  {
    title: "What makes SharpCode different from other coding schools?",
    desc: "SharpCode is an ISO and MSME-certified institution, ensuring high-quality education and legal compliance. Our courses are designed by industry experts to provide practical skills and real-world application.",
  },
  {
    title: "What support does SharpCode offer to its students?",
    desc: "Apart from the letter of recommendation, our outstanding performers are rewarded with goodies.",
  },
  {
    title: "Is there any special criteria or test to be selected for live projects?",
    desc: "There will be special rounds, students would be able to access after the completion of certification, and the projects may be paid.",
  },
  {
    title: "How does SharpCode ensure the quality of its courses?",
    desc: "Our courses are regularly updated to reflect the latest industry standards and technologies. Each course undergoes rigorous quality checks and is taught by instructors with real-world tech experience.",
  },
  {
    title: "What is SharpCode's policy on course cancellations or withdrawals?",
    desc: "At SharpCode, we encourage our students to carefully consider their schedule and commitments before enrolling in our courses. Due to the nature of our programming and resource allocation, we do not offer refunds once a course has begun. However, we are committed to helping students succeed and can provide guidance on other options if you are unable to continue your course.",
  },
]

export const courseOutline=[
  {
    name:"Android Development",
    Prerequisites:"Basic programming knowledge, Familiarity with OOPs, Experience with Git",
    Learnings:"Introduction to Flutter and Dart, Object-Oriented Programming in Dart, Common Widgets and Cards Knowledge, UI/UX Designing, State Management and Navigation, Firebase CLI and SDK Setup",
    Outcomes:"Proficiency in Flutter and Dart, Strong Understanding of OOP Concepts, UI/UX Design Skills, State Management and Navigation Expertise, Integration of Firebase Services, Preparedness for Android Development Projects",
    Duration:"4 Weeks",
    StartDate:"5 June",
    price:"999",
  },
  {
    name:"Data Analytics",
    Prerequisites:"Basic programming knowledge, Familiarity with OOPs, Experience with Git",
    Learnings:"Introduction to Data Analysis, SQL and Excel for Data Analysis, Data Visualization with Power BI and Tableau, Optional Python for Data Analysis, Real-world Data Analysis Projects",
    Outcomes:"Data Analysis Proficiency, Advanced SQL and Excel Skills, Effective Data Visualization, Python for Data Analysis, Practical Experience",
    Duration:"4 Weeks",
    StartDate:"5 June",
    price:"999",
  },
  {
    name:"Machine Learning",
    Prerequisites:"Basic Python Programming, Understanding of algebra, calculus, and statistics, Basic knowledge of libraries like NumPy and Pandas.",
    Learnings:" numpy, pandas, matplotlib, seaborn scikit learn, Supervised learning algorithms, Unsupervised learning algorithms",
    Outcomes:"Proficiency in Data Handling, Skill in Data Visualization, Understanding of Supervised and Unsupervised Learning, Preparation for Advanced Topics like deep learning and natural language processing",
    Duration:"4 Weeks",
    StartDate:"5 June",
    price:"999",
  },
  {
    name:"Data Science",
    Prerequisites:"Basic understanding of Python and libraries - Pandas, Numpy, Matplotlib, Scikit-Learn",
    Learnings:"Data Cleaning, Data manipulation, Data analysis, Exploratory data analysis(univariate, bivariate , multivariate), Model Building, Feature extraction, Hyperparameter tuning, Flask, Model Deployment, AWS EC2",
    Outcomes:" Proficiency in Data Cleaning and Manipulation, Strong Data Analysis Skills, Model Building and Tuning, Web Development with Flask, Experience in Model Deployment",
    Duration:"4 Weeks",
    StartDate:"5 June",
    price:"999",
  },
  {
    name:"Backend Development",
    Prerequisites:"Fundamental Web Development, Basic Programming Knowledge, Database Basics",
    Learnings:" Introduction and Web Servers, Programming Languages and Frameworks,Version Control and Web Security, Containerization, Testing, and Deployment Real-world Projects",
    Outcomes:"Design and Implement Backend Systems, Manage Web Servers, Use Version Control Systems, Ensure Web Security, Deploy Applications, Work on Real-world Projects, Troubleshoot and Optimize",
    Duration:"4 Weeks",
    StartDate:"5 June",
    price:"999",
  },
  {
    name:"Fullstack Development",
    Prerequisites:"Programming Knowledge, Basic Web Development, Computing Essentials",
    Learnings:" Intro to concepts, Frontend Development, Backend development, Database Management, Real-world Projects",
    Outcomes:" Build full Stack Applications, Create Dynamic Frontend, Development Robust Backends, Manage Database, Integrate Frontend and Backend, Work on Real-World Projects, Troubleshoot and Optimize",
    Duration:"4 Weeks",
    StartDate:"5 June",
    price:"999",
  },
  {
    name:"Language Fundamentals",
    Prerequisites:"Specially designed for a beginner in computer science field.",
    Learnings:"basic structure and syntax of the programming language, Control Structures (Loops and Conditional Statements), Operators and Object-Oriented Programming (OOP), File Handling and Advanced Topics",
    Outcomes:"strong understanding of the basic syntax and structure of a programming language, A strong logic building using conditional statements and loops, Grasp fundamental object-oriented programming concepts and create simple classes and objects, Perform basic file handling operations for reading and writing data.",
    Duration:"4 Weeks",
    StartDate:"5 June",
    price:"999",
  },
  {
    name:"Data Structure and Algorithms",
    Prerequisites:"Basic syntax knowledge of any programming language, Beginner oriented course",
    Learnings:"basics of data structures and algorithms with time and space complexity, Implementation and applications of basic data structures like array, stack, queue, linked lists, trees and graphs, Searching and Sorting techniques with hash tables and heaps",
    Outcomes:"Have a solid understanding of the basics of data structures and algorithms, A strong logic building, creating a firm base for any competitive coding test, Use advanced data structures like hash tables and heaps.",
    Duration:"4 Weeks",
    StartDate:"5 June",
    price:"999",
  },
  {
    name:"Frontend Development",
    Prerequisites:"Basic Computer Skills, Understanding of the Internet and Browsers, Basic Programming Knowledge",
    Learnings:"Basics of Frontend Development, HTML, CSS, Core & Advanced Javascript, Frondend frameworks",
    Outcomes:"Technical Proficiency, Project Experience, Job Readiness, Problem-solving and Debugging Skills, Continued Learning",
    Duration:"4 Weeks",
    StartDate:"5 June",
    price:"1",
  },
]
